export const renameIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21"><path fill="none" stroke="currentColor" stroke-width="1.5" d="M19.105 1.895a3.073 3.073 0 0 0-4.365.03L2.496 14.169 1.001 20l5.831-1.495L19.076 6.261a3.076 3.076 0 0 0 .03-4.365zM15 2l4 4m-6-2 4 4M3 14l4 4"/></svg>`,
    name: 'rename'
};